var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Foundation/Icon/16px/chevron_right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chevron_Right"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24979 18.7941L15.9685 12.0758L9.2432 5.19918C8.9164 4.86505 8.91933 4.32626 9.24979 3.99586C9.58024 3.66543 10.113 3.66845 10.4398 4.00261L17.7568 11.4842C18.0836 11.8184 18.0807 12.3571 17.7502 12.6876L10.4331 20.0041C10.1027 20.3346 9.56991 20.3316 9.24311 19.9974C8.91637 19.6632 8.9194 19.1245 9.24979 18.7941Z",
    fill: "#1F2532"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_4649",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 3,
    width: 9,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24979 18.7941L15.9685 12.0758L9.2432 5.19918C8.9164 4.86505 8.91933 4.32626 9.24979 3.99586C9.58024 3.66543 10.113 3.66845 10.4398 4.00261L17.7568 11.4842C18.0836 11.8184 18.0807 12.3571 17.7502 12.6876L10.4331 20.0041C10.1027 20.3346 9.56991 20.3316 9.24311 19.9974C8.91637 19.6632 8.9194 19.1245 9.24979 18.7941Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_4649)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.53070c10867a4554b618657180d4c3b3.svg";
export { ForwardRef as ReactComponent };